"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPriceGet200ResponseToJSON = exports.ApiPriceGet200ResponseFromJSONTyped = exports.ApiPriceGet200ResponseFromJSON = exports.instanceOfApiPriceGet200Response = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ApiPriceGet200Response interface.
 */
function instanceOfApiPriceGet200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiPriceGet200Response = instanceOfApiPriceGet200Response;
function ApiPriceGet200ResponseFromJSON(json) {
    return ApiPriceGet200ResponseFromJSONTyped(json, false);
}
exports.ApiPriceGet200ResponseFromJSON = ApiPriceGet200ResponseFromJSON;
function ApiPriceGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
    };
}
exports.ApiPriceGet200ResponseFromJSONTyped = ApiPriceGet200ResponseFromJSONTyped;
function ApiPriceGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'price': value.price,
    };
}
exports.ApiPriceGet200ResponseToJSON = ApiPriceGet200ResponseToJSON;
